import React, { Component } from 'react'
import { Map, TileLayer, LayersControl, Marker, Popup, Tooltip, CircleMarker } from 'react-leaflet'
import { GoogleLayer } from 'react-leaflet-google-v2'
import L from 'leaflet'
import LocateControl from './LocateControl';
import PropTypes from 'prop-types';
import { translate } from 'react-switch-lang';
import Control from 'react-leaflet-control';

// Resource rows use flat Latitude/Longitude; service rows use Mongo-style nested numbers (see ServiceFilter normalization).
 
function iconCreation(iconLink){
	return new L.Icon({
		  iconUrl: iconLink,
		  iconRetinaUrl: iconLink,
		  iconAnchor: [0, 0],
		  popupAnchor: [0, 0],
		  iconSize: [25,25],
		  shadowUrl: iconLink,
		  shadowSize: [25, 25],
		  shadowAnchor: [0, 0],
		})
}

function numberCreation(number){
	return new L.divIcon({
		  className:'dot',
		  html:number,
		  iconAnchor: [0, 0],
		  popupAnchor: [0, 0],
		  iconSize: [25,25],
		  shadowSize: [25, 25],
		  shadowAnchor: [0, 0],
		})
}

// `cat` must match `location.Category` strings from the API (English names) so markers resolve to the right asset.
var iconDict = [
	{cat:'Elderly / Disabled Services', url:'icons/access.png'},
	{cat:'Haircut', url:'icons/scissors.png'},
	{cat:'Food', url:'icons/food.png'},
	{cat:'Tangible Goods', url:'icons/boxes.png'},
	{cat:'Meals', url:'icons/meal.png'},
	{cat:'Medical Services',url:'icons/medical.png'},
	{cat:'Repair', url:'icons/screwdriver.png'},
	{cat:'Street Sleepers Services', url:'icons/house.png'},
	{cat:'Children & Youth Services', url:'icons/shield.png'},
	{cat:'Community Development', url:'icons/family.png'},
	{cat:'Disability Services', url:'icons/access.png'},
	{cat:'District Social Welfare Offices', url:'icons/district.png'},
	{cat:'Elderly Services', url:'icons/old-man.png'},
	{cat:'Family & Child Welfare Services', url:'icons/family.png'},
	{cat:'Family and Integrated Services', url:'icons/family.png'},
	{cat:'Medical Social Services', url:'icons/medical.png'},
	{cat:'Rehabilitation and Medical Social Services', url:'icons/medical.png'},
	{cat:'Services for Offenders', url:'icons/district.png'},
	{cat:'Services for the Elderly', url:'icons/old-man.png'},
	{cat:'Services for Young People', url:'icons/shield.png'},
	{cat:'Social Security', url:'icons/shield.png'},
	{cat:'Ethnic Minorities', url:'icons/ethnic.png'},
]
const locateOptions = {
  position: 'topright',
  enableHighAccuracy: true,
  keepCurrentZoomLevel: true,
  initialZoomLevel:14,
  onActivate: () => {} // callback before engine starts retrieving locations
}
class ResourceMap extends Component {
   state = {
       zoom: 13,
       numbers:false
   }
   onClickTooltip = () => {
    this.setState({tooltip:false})
  }
   showAlert = () => {
  }

   onClickButton = () => {
   	let numbers = this.state.numbers
   	if(numbers == false)
   	{
    	this.setState({numbers:true})
	}
	else
	{
		this.setState({numbers:false})
	}
  }
   render() {
   	const { BaseLayer} = LayersControl;
	const key = 'AIzaSyB3p-eqYbX0xDakRDS4EbimydgCLfCNRZQ';
	const terrain = 'TERRAIN';
	const road = 'ROADMAP';
	const satellite = 'SATELLITE';
	const hydrid = 'HYBRID';
   	const { t } = this.props;
   	const tooltip = this.props.tootlip;
   	const isResource = this.props.isResource;
   	const start = this.props.start
   	
   	// Validate and provide default coordinates if invalid
   	const lat = parseFloat(this.props.lat);
   	const lng = parseFloat(this.props.lng);
   	const zoom = parseFloat(this.props.zoom);
   	
   	// Default coordinates (Hong Kong)
   	const defaultLat = 22.29442;
   	const defaultLng = 114.17274;
   	const defaultZoom = 10;
   	
   	// Use defaults if coordinates are invalid
   	const validLat = (!isNaN(lat) && isFinite(lat)) ? lat : defaultLat;
   	const validLng = (!isNaN(lng) && isFinite(lng)) ? lng : defaultLng;
   	const validZoom = (!isNaN(zoom) && isFinite(zoom) && zoom > 0) ? zoom : defaultZoom;
   	
   	// Log error if invalid coordinates were provided
   	if (isNaN(lat) || isNaN(lng) || !isFinite(lat) || !isFinite(lng)) {
   		console.error(`🚨 ResourceMap: Invalid map center coordinates provided:`, {
   			lat: this.props.lat,
   			lng: this.props.lng,
   			latParsed: lat,
   			lngParsed: lng,
   			usingDefaults: { lat: validLat, lng: validLng, zoom: validZoom }
   		});
   	}
   	
        return (
	              <Map center={[validLat, validLng]} 
				    zoom={validZoom} 
  					className='resourceMap'
  					onFocus={this.props.closeFilter}
  					>
				  <Control position="topright" >

					<label class="label">
					      <div class="button-cover">
					  <div class="toggle">
					    <input class="toggle-state" type="checkbox" name="check" value="check" onChange={ this.onClickButton } />
					    <div class="indicator"></div>
					  </div>
					  <div class="label-text">{t('Icons')}</div>
					  </div>
					</label>
			      </Control>

  					<LocateControl options={locateOptions}/>
  					<LayersControl position='topright'>
			          <BaseLayer  name='OpenStreetMap.Mapnik'>
			            <TileLayer  url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"/>
			          </BaseLayer>
			         <BaseLayer checked name='Google Maps Roads'>
			            <GoogleLayer googlekey={key}  maptype={road} />
			          </BaseLayer>     
			        </LayersControl>
			      {
				  	((!isResource) && (this.props.tooltip))
				  	?<CircleMarker onClick={this.onClickTooltip} center={[22.29442, 114.17274]} color="red" radius={1}>
			          <Tooltip permanent>{t('Tooltip')}</Tooltip>
			         </CircleMarker>
				  	:<div></div>
				  }
				  	{this.props.locations
				  		.filter(location => {
				  			// Safety check: Filter out locations with invalid coordinates before rendering
				  			if (isResource) {
				  				const lat = location['Latitude'];
				  				const lng = location['Longitude'];
				  				const latNum = parseFloat(lat);
				  				const lngNum = parseFloat(lng);
				  				if (!lat || !lng || isNaN(latNum) || isNaN(lngNum) || !isFinite(latNum) || !isFinite(lngNum) || lat === "NaN" || lng === "NaN") {
				  					console.error(`🚨 ResourceMap: Skipping location with invalid coordinates:`, {
				  						name: location[t('columns.Name')],
				  						index: location['index'],
				  						Latitude: lat,
				  						Longitude: lng,
				  						latParsed: latNum,
				  						lngParsed: lngNum
				  					});
				  					return false;
				  				}
				  				return true;
				  			} else {
				  				const lat = location['Latitude']?.['$numberDouble'];
				  				const lng = location['Longitude']?.['$numberDouble'];
				  				const latNum = parseFloat(lat);
				  				const lngNum = parseFloat(lng);
				  				if (!lat || !lng || isNaN(latNum) || isNaN(lngNum) || !isFinite(latNum) || !isFinite(lngNum) || lat === "NaN" || lng === "NaN" || lat === "Infinity" || lng === "Infinity") {
				  					const locationName = location[t('columns.ServiceName')] || location['Name'] || location['機構名稱'] || 'Unknown';
				  					const locationIndex = location['index']?.['$numberInt'] || location['index'] || 'Unknown';
				  					console.error(`🚨 ResourceMap: Skipping location with invalid coordinates:`, {
				  						name: locationName,
				  						index: locationIndex,
				  						Latitude: location['Latitude'],
				  						Longitude: location['Longitude'],
				  						latValue: lat,
				  						lngValue: lng,
				  						latParsed: latNum,
				  						lngParsed: lngNum,
				  						fullLocation: location
				  					});
				  					return false;
				  				}
				  				return true;
				  			}
				  		})
				  		.map(location => {
				  			// Double-check coordinates are valid before creating point array
				  			var point;
				  			var numberIcon = numberCreation(location['index'])

				  			if(isResource) 
				  			{
				  				const lat = parseFloat(location['Latitude']);
				  				const lng = parseFloat(location['Longitude']);
				  				if (isNaN(lat) || isNaN(lng) || !isFinite(lat) || !isFinite(lng)) {
				  					console.error(`🚨 ResourceMap: Invalid coordinates in point creation (resource):`, {
				  						Latitude: location['Latitude'],
				  						Longitude: location['Longitude'],
				  						latParsed: lat,
				  						lngParsed: lng
				  					});
				  					return null; // Skip this marker
				  				}
				  				point = [lat, lng];
				  				numberIcon = numberCreation(location['index'])
				  			}
				  			else { 
				  				const lat = parseFloat(location['Latitude']['$numberDouble']);
				  				const lng = parseFloat(location['Longitude']['$numberDouble']);
				  				if (isNaN(lat) || isNaN(lng) || !isFinite(lat) || !isFinite(lng)) {
				  					console.error(`🚨 ResourceMap: Invalid coordinates in point creation (service):`, {
				  						Latitude: location['Latitude'],
				  						Longitude: location['Longitude'],
				  						latParsed: lat,
				  						lngParsed: lng
				  					});
				  					return null; // Skip this marker
				  				}
				  				point = [lat, lng];
				  				numberIcon = numberCreation(location['index']['$numberInt'])
				  			}
							
							  const pointerIcon = (() => {
								try {
								  const categoryIcon = iconDict.filter(cat => cat.cat === location.Category)[0];
								  if (!categoryIcon || !categoryIcon.url) {
									throw new Error('No icon found for category');
								  }
								  return iconCreation(categoryIcon.url);
								} catch (error) {
								  // Return a default icon if anything fails
								  return iconCreation('https://www.shareicon.net/data/2016/09/23/833798_boxes_512x512.png;width=25;height=25'); // Replace with your default icon path
								}
							  })();
							  
							  // Skip rendering if point is null (invalid coordinates)
							  if (!point) {
							  	return null;
							  }
							  
							  return (
								<div>
								<Marker position={point} key={numberIcon} icon=
									{this.state.numbers
										? numberIcon
										: pointerIcon
									} >
								{isResource 
									?  <Popup>
								         	<span><b>{t('columns.Name')}:</b>{location[t('columns.Name')]}</span><br/>
								            <span><b>{t('columns.Address')}:</b> {location[t('columns.Address')]}</span><br/>
								            <span><b>{t('columns.Telephone')}:</b> {location[t('columns.Telephone')]}</span><br/>
								            <span><b>{t('columns.Nature')}</b> {location[t('columns.Nature')]}</span><br/>
								            <span><b>{t('columns.Target')}:</b> {location[t('columns.Target')]}</span><br/>
								         </Popup>
									: 	
								         <Popup>
								            <span><b>{t('columns.ServiceName')}:</b> {location[t('columns.ServiceName')]}</span><br/>
								            <span><b>{t('columns.Address')}:</b> {location[t('columns.Address')]}</span><br/>
								            <span><b>{t('columns.ServiceTelephone')}:</b> {location[t('columns.ServiceTelephone')]}</span><br/>
								            <span><b>{t('columns.Facility')}</b> {location[t('columns.Facility')]}</span><br/>
								         </Popup>
								}
								</Marker>
								</div>							
				 			)})}
					       	</Map>
       )	
   }
}

ResourceMap.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(ResourceMap);

{/*
	<Marker position={point} key={location['index']} icon={pointerIcon} >
         <Popup>
         	<span><b>{t('columns.Name')}:</b>{location[t('columns.Name')]}</span><br/>
            <span><b>{t('columns.Address')}:</b> {location[t('columns.Address')]}</span><br/>
            <span><b>{t('columns.Telephone')}:</b> {location[t('columns.Telephone')]}</span><br/>
            <span><b>{t('columns.Nature')}</b> {location[t('columns.Nature')]}</span><br/>
            <span><b>{t('columns.Target')}:</b> {location[t('columns.Target')]}</span><br/>
         </Popup>
     </Marker>
*/}
